const progressBar = () => {
    const progressBar = document.querySelector('.progress-bar__content');
    if (progressBar) {
        window.onscroll = () => {
            let winScroll = document.body.scrollTop || document.documentElement.scrollTop;
            let height = document.documentElement.scrollHeight - document.documentElement.clientHeight;
            let scrolled = (winScroll / height) * 100;
            progressBar.style.width = scrolled + "%";
        }
    }
};

export default progressBar;